// extracted by mini-css-extract-plugin
module.exports = {"returns":"_6e798ba","description":"_08b6fd1","value":"_8ba1302","returnValue":"_f7cd2d0","returnValuePriceChange":"_bc437af","bonusCash":"_47d3dbc"};